import * as React from 'react';
import { SVGProps } from 'react';

const IconCalendarSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1a1 1 0 0 0-1 1v1H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2V2a1 1 0 1 0-2 0v1H6V2a1 1 0 0 0-1-1zM3 7h10v6H3V7z"
    />
  </svg>
);
export default IconCalendarSizeS;
